"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TICKETS = exports.INCARCERATION_FEES = exports.COURT_FEES = exports.TAXES = exports.PUBLIC_STUDENT_LOANS = exports.PRIVATE_STUDENT_LOANS = void 0; // Education

exports.PRIVATE_STUDENT_LOANS = "private_student_loans";
exports.PUBLIC_STUDENT_LOANS = "public_student_loans"; // Government

exports.TAXES = "taxes";
exports.COURT_FEES = "court_fees";
exports.INCARCERATION_FEES = "incarceration_fees";
exports.TICKETS = "tickets";